import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import './styles/WhyBuy.css';

function WhyBuy() {

    useEffect(() => {
    let scrollTracked = false; // evita múltiplos disparos

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      const scrollPercent = (scrollTop + windowHeight) / docHeight * 100;

      if (scrollPercent >= 50 && !scrollTracked) {
        scrollTracked = true;

        // 🔹 Envia evento pro Pixel
        ReactPixel.trackCustom('ScrollDepth50', {
          depth: '50%',
          page: window.location.pathname,
        });
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="WhyBuy">
            <h3>Ao longo do curso, você vai aprender a:</h3>
            <div className="cards">
                <div className="card fade-in-up">
                    <p>Calcular corretamente a <strong> Zona Livre de queda</strong>;</p>
                </div>
                <div className="card-alternate fade-in-up">
                    <p>Saber <strong>QUANDO e QUANTO</strong> irá abrir o absorvedor de energia do talabarte;</p>
                </div>
                <div className="card fade-in-up">
                    <p>Escolher o <strong>talabarte</strong> e o <strong>trava quedas retrátil adequado</strong> para cada atividade;</p>
                </div>
                <div className="card-alternate fade-in-up">
                    <p><strong>Evitar erros</strong> comuns cometidos por profissionais no uso diário;</p>
                </div>
                <div className="card fade-in-up">
                    <p>Determinar a <strong>zona livre de queda</strong> em diferentes cenários;</p>
                </div>
                <div className="card-alternate fade-in-up">
                    <p>Aplicar as exigências da <strong>NR-35</strong> e da <strong>ABNT NBR 16489 </strong>e <strong> ABNT NBR 15834</strong> com segurança e confiança;</p>
                </div>
            </div>
        </div>
    )
};

export default WhyBuy;